
import { WafResponseError } from '@packages/toolbox';
// @ts-ignore
import { captureException } from '@sentry/vue';
import { defineComponent, onMounted, ref } from 'vue';

import WafDialog from 'SharedComponents/base/WafDialog.vue';
import { useNotificationStore } from 'SharedDir/stores/notification.store';

import { WAF_SUPPORT } from 'src/constants/app/common';

export default defineComponent({
  name: 'WafDialogWrapper',
  data() {
    return {
      WAF_SUPPORT,
    };
  },
  components: {
    WafDialog,
  },
  setup() {
    const notificationStore = useNotificationStore();

    const subscriber = ref<null | (() => void)>(null);

    onMounted(() => {
      subscriber.value = notificationStore.$onAction(({ name }) => {
        if (name === 'setWafError') {
          const { id, url } = notificationStore.wafError;
          captureException(new WafResponseError(notificationStore.wafError), {
            extra: { id, url },
            tags: {
              WAFFRONTALARM: true,
            },
          });
        }
      });
    });
  },
});
